export default {
      id: "warningSign-usage",
      viewBox: "0 0 16 16",
      url: "/" + "img/marilyn-ui.svg#warningSign",
      toString: function () {
        return this.url;
      }
    }